import EnumService from '@/services/enum.service'
import Utils from '@/common/utils'

const AuditUtils = {
    translateAction(value) {
        const action = EnumService.AuditActionTypeList.find(x => x.value == value);
        if (action) {
            return action.text;
        }

        return value;
    },

    translateModule(value) {
        const module = EnumService.AuditModuleTypeList.find(x => x.value == value);
        if (module) {
            return module.text;
        }

        return value;
    },

    parseEntity(entityName, entity, action, includeAllValues) {
        let currentValue = [];
        let originalValue = [];
        Object.keys(entity).forEach((j) => {
            const value = entity[j];
            if (j == 'CurrentValue') {
                Object.keys(value).forEach((k) => {
                    currentValue.push({name: k, value: value[k]});
                });
            } else if (j == 'OriginalValue') {
                Object.keys(value).forEach((k) => {
                    originalValue.push({name: k, value: value[k]});
                });
            }
        });

        const entityAction = currentValue.length != 0 && originalValue.length == 0 ? 
                                'WAA_INSERT' : 
                                (currentValue.length == 0 && originalValue.length != 0 ? 'WAA_DELETE' : 'WAA_UPDATE');

        const values = [];
        currentValue.forEach((element) => {
            const original = originalValue.find(x => x.name == element.name);
            const status = (entityAction == 'WAA_INSERT') ? 
                                (Utils.isNullOrEmptyString(element.value) ? 'CURRENT' : 'NEW') :
                                (entityAction == 'WAA_UPDATE' && (!original || element.value == original.value) ? 'CURRENT' : 'UPDATE');

            if (includeAllValues || status == 'NEW' || status == 'UPDATE') {
                values.push({name: element.name, value: element.value ?? '', old: original?.value ?? null, status: status, isHtmlFormat: this.isHtmlControl(entityName, element.name)});
            }
        });

        originalValue.forEach((element) => {
            if (includeAllValues || entityAction == 'WAA_DELETE') {
                const original = currentValue.find(x => x.name == element.name);
                if (!original) {
                    const status = Utils.isNullOrEmptyString(element.value) ? 'CURRENT' : 'DELETE';
                    if (includeAllValues || status == 'DELETE') {
                        values.push({name: element.name, value: '', old: element.value ?? '', status: status, isHtmlFormat: this.isHtmlControl(entityName, element.name)});
                    }   
                }
            }
        });

        return values;
    },

    isHtmlControl(entity, controlName) {
        return (entity == 'ActivitieTable' && controlName == 'Memoinfo') ||
            (entity == 'DailyNoteTable' && controlName == 'Comments');
    },

    splitCommaText(value) {
        const result = [];
        let str = value;
        if (!Utils.isNullOrEmptyString(str)) {
            str = str.trim();
            const length = str.length;
            let position = 0;
            let nextPosition = 0;
            while (position < length) {
                if (str[position] == ',' || str[position] == ' ') {
                    position++;
                    continue;
                }

                if (str[position] == '"') {
                    nextPosition = str.indexOf('"', position + 1);
                    if (nextPosition == -1) {
                        result.push(str.substr(position + 1));
                        break;
                    }
                    result.push(str.substr(position + 1, nextPosition - (position + 1)));
                    position += (nextPosition - position) + 1;
                    continue;
                }

                nextPosition = str.indexOf(',', position);
                if (nextPosition == -1) {
                    result.push(str.substr(position));
                    break;
                }
                result.push(str.substr(position, nextPosition - (position)));
                position += (nextPosition - position);
            }
        }

        return result;
    },

    getTableFromXml(xmlString) {
        if (!Utils.isNullOrEmptyString(xmlString)) {
            var primaryKey = null;
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString(xmlString, "text/xml");

            const columns = [];
            const attributeType = xmlDoc.getElementsByTagName("s:AttributeType");
            if (attributeType) {           
                for (let item of attributeType) {
                    const autoincrement = item.attributes['rs:autoincrement'];
                    if (autoincrement && autoincrement.nodeValue == 'true') {
                        primaryKey = item.attributes['name'].nodeValue
                        continue;
                    }
                    
                    let columnType = 'string';
                    const dsType = item.getElementsByTagName("s:datatype");
                    if (dsType) {
                        columnType = dsType[0]?.attributes['dt:type']?.nodeValue ?? 'string';
                    }

                    columns.push({name: item.attributes['name'].nodeValue, type: columnType});
                }
            }

            const data = [];
            const rows = xmlDoc.getElementsByTagName("z:row");
            if (rows) {
                for (let row of rows) {
                    const r = [];
                    for (let item of row.attributes) {
                        r.push({column: item.name, value: item.nodeValue});
                    }

                    if (r.length != 0) {
                        data.push(r);
                    }
                }
            }

            return {columns: columns, data: data, primaryKey: primaryKey}
        }

        return xmlString;
    },

    createNoteTable(tableObj) {
        const primaryKey = tableObj.tableContents?.primaryKey ?? tableObj.oldTableContents?.primaryKey;
        
        //Make Columns
        const tableHeader = [];
        tableObj.tableContents?.columns.forEach((column) => {
            tableHeader.push({name: column.name, type: column.type, rowsWithData: 0});
        });

        tableObj.oldTableContents?.columns.forEach((column) => {
            if (tableHeader.map(x => x.name).indexOf(column.name) == -1) {
                tableHeader.push({name: column.name, type: column.type, rowsWithData: 0});
            }
        });

        //Make Rows
        const tableBody = [];
        tableObj.tableContents?.data.forEach((row) => {
            const tableColumns = [];
            let columnsWithData = 0;
            const columnKey = row.find(x => x.column == primaryKey);

            row.forEach((column) => {
                if (column.column != primaryKey) {
                    tableColumns.push({column: column.column, value: column.value, old: null, status: 'NEW'});
                    columnsWithData += !Utils.isNullOrEmptyString(column.value) ? 1 : 0;
                }
            });

            tableBody.push({rowKey: columnKey?.value, columnsWithData: columnsWithData, columnsWithDataUnmodified: 0, columns: tableColumns});
        });

        tableObj.oldTableContents?.data.forEach((row) => {
            const columnKey = row.find(x => x.column == primaryKey);
            const primaryRow = tableBody.find((row) => row.rowKey == columnKey?.value);
            let columnsWithData = 0;
            
            const tableRow = [];
            row.forEach((column) => {
                if (column.column != primaryKey) {
                    if (primaryRow) {
                        const columnInRow = primaryRow.columns.find(x => x.column == column.column);
                        if (columnInRow) {
                            columnInRow.old = column.value;
                            columnInRow.status = column.value == columnInRow.value ? 'CURRENT' : 'UPDATE';
                            primaryRow.columnsWithDataUnmodified += columnInRow.status == 'CURRENT' ? 1 : 0;
                        } else {
                            primaryRow.columns.push({column: column.column, value: null, old: column.value, status: 'DELETE'});
                            primaryRow.columnsWithData += !Utils.isNullOrEmptyString(column.value) ? 1 : 0;
                        }
                    } else {
                        tableRow.push({column: column.column, value: null, old: column.value, status: 'DELETE'});
                        columnsWithData += !Utils.isNullOrEmptyString(column.value) ? 1 : 0;
                    }
                }
            });

            if (!primaryRow) {
                tableBody.push({rowKey: columnKey?.value, columnsWithData: columnsWithData, columnsWithDataUnmodified: 0, columns: tableRow});
            }
        });

        tableHeader.forEach((column) => {
            column.rowsWithData = this.getRowsWithData(column.name, tableBody);
        });

        return {
            tableId: tableObj.tableId, 
            headerId: tableObj.headerId, 
            recId: tableObj.recId, 
            status: tableObj.status, 
            header: tableHeader, 
            body: tableBody
        };
    },

    getRowsWithData(column, tableBody) {
        let result = 0;
        tableBody.forEach((element) => {
            const col = element.columns.find(x => x.column == column);
            if (col) {
                result += col.status != 'CURRENT' ? 1 : 0;
            }
        });

        return result;
    }
};

export default AuditUtils;